
















import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { CustomNode } from '../../../../../../Nodes'
import {
  systemLabelsRecord
} from '../../../../../Communications/Action/logic/Actions/LabelsAction/SYSTEM_LABELS'
import LabelCondition from '../../../logic/ConditionTypes/LabelConditions/LabelCondition'

@Component({
  data() {
    return {
      snakeCase,
    }
  }
})
export default class LabelConditionView extends Vue {
  @Prop() condition!: LabelCondition

  @Prop() labels!: { [key: string]: string }

  labelName(index: number): string {
    const labels: Record<string, string> = { ...systemLabelsRecord(CustomNode.i18n), ...this.labels }

    return labels[index]
  }
}
